export const LANDING_CONTACT = {
  email: "info@mysocietymitra.com",
  phoneDisplay: "756-756-9060 | 8080-220-880",
  phones: [
    { label: "756-756-9060", href: "tel:+917567569060" },
    { label: "8080-220-880", href: "tel:+918080220880" },
  ],
  website: "www.mysocietymitra.com",
  websiteHref: "https://www.mysocietymitra.com/",
  whatsappHref: "https://wa.me/918080220880",
};

export const PARTNER_PRICING = {
  vendor: {
    price: "₹500/year + applicable GST",
    badge: "Free application",
    successFee: "5% standard success fee",
  },
  technician: {
    price: "Free to Join",
    launchNote: "No annual subscription at launch",
    commission: "20% commission on net visiting and labour charges",
  },
  expert: {
    price: "Free Registration",
    launchNote: "No compulsory subscription at launch",
  },
};

export function formatRupeesFromPaise(paise) {
  const value = Number(paise || 0) / 100;
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function parseSocietyUnits(value) {
  const text = String(value ?? "").trim();
  if (!text) {
    return { valid: false, error: "Enter the number of enrolled flats or shops." };
  }
  if (!/^\d+$/.test(text) || Number(text) <= 0) {
    return { valid: false, error: "Use a positive whole number of flats or shops." };
  }
  const units = Number(text);
  if (!Number.isSafeInteger(units)) {
    return { valid: false, error: "Enter a valid whole number of flats or shops." };
  }
  return { valid: true, units };
}

export function pricingEnquirySummary(quote) {
  if (!quote || quote.status === "custom_quote") {
    return `Custom Society pricing enquiry: ${quote?.units || ""} enrolled flats/shops; ` +
      `subscription duration: ${quote?.duration_months || ""} months.`;
  }
  const portalLabel = quote.resident_portal_selected ? "selected" : "not selected";
  return `Society launch-pricing enquiry: ${quote.units} enrolled flats/shops; ` +
    `${quote.duration_months}-month duration; Resident Portal: ${portalLabel}; ` +
    `indicative payable amount: ${formatRupeesFromPaise(quote.final_payable_paise)}; ` +
    `policy ${quote.policy?.policy_version || "current"}.`;
}